export type ConfigurableField = {
  value: string | null;
  name: string;
  displayName: string;
  required: boolean;
  type: FieldTypes;
  typeMetadata: Record<string, unknown>;
};

export enum FieldTypes {
  STRING = 'string',
  ARRAY = 'array',
  FILE = 'file'
}

export type SocialConnection = {
  configurable_fields: ConfigurableField[];
  connected: boolean;
  is_custom: boolean;
  provider: string;
  one_tap_login?: {
    enabled: boolean;
  };
};

export type SocialConnectionsResponse = SocialConnection[];

export type ConnectorValues = {
  client_id?: string | null;
  client_secret?: string | null;
  one_tap_login?: {
    enabled: boolean;
  };
};

export type ConnectProps = {
  projectId: string;
  provider: string;
  values?: ConnectorValues;
};

export type CustomScopes = {
  custom_scope: string[];
  refresh_always: boolean;
};

export type CustomScopesResponse = CustomScopes & {
  add_social_token: boolean;
};

export type PutCustomScopes = CustomScopes & {
  projectId: string;
  providerName: string;
};
